import { Controller } from "@hotwired/stimulus";

/**
 * Controls visibility of user form fields based on selected user type(s).
 *
 * Targets:
 * - userType: The select element for user type
 * - studentFields: Container for student-specific fields
 * - guestFields: Container for guest-specific fields
 * - emailHint: The email hint text (shown when NOT guest)
 */
export default class extends Controller {
  static targets = ["userType", "studentFields", "guestFields", "emailHint"];

  connect() {
    this.updateFieldVisibility();
  }

  updateFieldVisibility() {
    const selectedTypes = this.getSelectedUserTypes();

    this.toggleTarget("studentFields", selectedTypes.includes("student"));
    this.toggleTarget("guestFields", selectedTypes.includes("guest"));

    // Email hint shows when user is NOT guest
    const showEmailHint = !selectedTypes.includes("guest") && selectedTypes.length > 0;
    this.toggleTarget("emailHint", showEmailHint);
  }

  getSelectedUserTypes() {
    if (!this.hasUserTypeTarget) {
      return [];
    }

    const select = this.userTypeTarget;
    const selectedOptions = Array.from(select.selectedOptions);
    return selectedOptions.map((option) => option.value);
  }

  toggleTarget(targetName, show) {
    const hasTarget = this[`has${this.capitalize(targetName)}Target`];
    if (!hasTarget) {
      return;
    }

    const target = this[`${targetName}Target`];
    target.classList.toggle("d-none", !show);
  }

  capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
}
